/* eslint-disable consistent-return */
import React from 'react'
import { Link } from 'react-router-dom'
import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser'
import { attributesToProps, domToReact, Element } from 'html-react-parser'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { scrollTo } from '@/utils/helpers'
import {
  PublicationBanner,
  PublicationBannerDeprecated,
  PublicationFinancingWidget,
  PublicationImage,
  PublicationMedia,
  PublicationReadMore,
  PublicationSubscribe,
} from './components'

const { image, banner, media, readMore, subscribe, format, colors, articleBanner, financingWidget } = JOURNAL_TAG_ATTRIBUTES

export const TRANSFORM_OPTIONS: HTMLReactParserOptions = {
  replace(domNode) {
    if (!(domNode instanceof Element)) return

    // add classes, transform existing HTML elements
    if (domNode.name === 'h2') {
      const props = attributesToProps(domNode.attribs)

      return (
        <h2 className="h3" {...props}>
          {domToReact(domNode.children as DOMNode[], TRANSFORM_OPTIONS)}
        </h2>
      )
    }

    if (domNode.name === 'h3') {
      const props = attributesToProps(domNode.attribs)

      return (
        <h3 className="h4" {...props}>
          {domToReact(domNode.children as DOMNode[], TRANSFORM_OPTIONS)}
        </h3>
      )
    }

    if (domNode.name === 'a' && domNode.attribs.href?.startsWith('#')) {
      const props = attributesToProps(domNode.attribs)

      return (
        <Link {...props} to={domNode.attribs.href as string} onClick={() => scrollTo(domNode.attribs.href as string, undefined, false)}>
          {domToReact(domNode.children as DOMNode[], TRANSFORM_OPTIONS)}
        </Link>
      )
    }

    if (!domNode.attribs || (domNode.attribs && Object.keys(domNode.attribs).length === 0)) return

    if (domNode.attribs[colors.main] === colors.modifiers.accent && domNode.name === 'span') {
      return <span className="font-weight_light-bold textColored">{domToReact(domNode.children as DOMNode[], TRANSFORM_OPTIONS)}</span>
    }

    if (domNode.name === 'ul' && domNode.attribs[format.main] === format.modifiers.contents) {
      return <ul className="articleContents">{domToReact(domNode.children as DOMNode[], TRANSFORM_OPTIONS)}</ul>
    }

    // IMAGES
    if (domNode.attribs[image.main] !== undefined) {
      return <PublicationImage attribs={domNode.attribs} />
    }

    // BANNERS DEPRECATED
    if (domNode.attribs[banner.main] !== undefined) {
      return <PublicationBannerDeprecated attribs={domNode.attribs} />
    }

    // ARTICLE BANNERS
    if (domNode.attribs[articleBanner.web] !== undefined) return <PublicationBanner attribs={domNode.attribs} />

    if (domNode.attribs[articleBanner.app] !== undefined && domNode.attribs[articleBanner.web] === undefined) return <></>

    // MEDIA
    if (domNode.attribs[media.main] !== undefined) {
      return <PublicationMedia attribs={domNode.attribs} />
    }

    // Читайте также
    if (domNode.attribs[readMore.main] !== undefined) return <PublicationReadMore attribs={domNode.attribs} />

    // Подпишитесь на канал
    if (domNode.attribs[subscribe.main] !== undefined) return <PublicationSubscribe attribs={domNode.attribs} />

    // Финансовый виджет
    if (domNode.attribs[financingWidget.main] !== undefined) return <PublicationFinancingWidget attribs={domNode.attribs} />
  },
}
